import React from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Field } from 'formik';

import { CONSTANT, storeCodeOutletMapping, storeCodes } from '../../utils/constant';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';

const CorpStoreForm = ({ values, labels, touched, errors,setFieldValue }) => {

    const getMappedOutletId = storeCodeValue => {
        return storeCodeOutletMapping[storeCodeValue] || null;
  };
    const {
        KEYS: { ROLES }
    } = CONSTANT;
    return (
        <>
            <div className="main-content-form-headers">
                <span className="select-placeholder">{labels.STORE_CODE}</span>
            </div>
            <div
                style={{ position: 'relative' }}
                className={`input-container ${errors.storeCode && touched.storeCode ? 'error' : ''
                    }`}
            >
                <Typeahead
                    id="single-typehead"
                    placeholder={labels.PLACEHOLDER_STORE_CODE}
                    selected={values.storeCode ? [values.storeCode] : []} // Use selected
                    onChange={(selected) => {
                        const selectedCode = selected[0] || '';
                        setFieldValue('storeCode', selectedCode);
                        const mappedOutlet = getMappedOutletId(selectedCode);
                        if (mappedOutlet) {
                            setFieldValue('outlet', mappedOutlet);
                        }
                    }}
                    options={storeCodes}
                />

                <>
                    <div className="error_messages">
                        <span className="registration-error">{errors.storeCode}</span>
                    </div>
                    <div id="username_error_icon" className="error_messages_icon">
                        <img src={ErrorIcon} alt="error_icon" />
                    </div>
                </>
            </div>

      {/* <div className="main-content-form-headers">
        <span className="select-placeholder">{labels.XID_TID}</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.xid && touched.xid ? 'error' : ''
        }`}
      >
        <Field
          placeholder="XID/TID"
          className="select-style"
          type="text"
          name="xid"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.xid}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div> */}
    </>
  );
};

CorpStoreForm.propTypes = {
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired
};

export default CorpStoreForm;
